import { AbstractControl, ValidatorFn } from '@angular/forms'

export function addressValidator(isOptional): ValidatorFn {
  return function validate(formGroup: AbstractControl) {
    const userHasConfirmed = formGroup.value.userConfirmed

    if (!userHasConfirmed && !isOptional) {
      return {
        addressValidator: true
      }
    }
  }
}
